import type { SVGProps } from 'react'

type IconName =
  | 'home'
  | 'users'
  | 'graduationCap'
  | 'clipboardCheck'
  | 'wallet'
  | 'creditCard'
  | 'settings'
  | 'calendar'
  | 'building'
  | 'listChecks'
  | 'bookOpen'
  | 'search'
  | 'plus'
  | 'chevronRight'
  | 'chevronDown'
  | 'check'
  | 'x'
  | 'alert'
  | 'inbox'
  | 'fileText'
  | 'logOut'

const paths: Record<IconName, string[]> = {
  home: ['M3 11l9-8 9 8v9a2 2 0 0 1-2 2h-4v-7h-6v7H5a2 2 0 0 1-2-2v-9z'],
  users: [
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
    'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
    'M22 21v-2a4 4 0 0 0-3-3.87',
    'M16 3.13a4 4 0 0 1 0 7.75',
  ],
  graduationCap: [
    'M22 10v6',
    'M2 10l10-5 10 5-10 5z',
    'M6 12v5c3 3 9 3 12 0v-5',
  ],
  clipboardCheck: [
    'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2',
    'M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v0z',
    'M9 14l2 2 4-4',
  ],
  wallet: [
    'M21 12V8a2 2 0 0 0-2-2H5a2 2 0 0 1 0-4h12a2 2 0 0 1 2 2',
    'M3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4',
    'M18 14h.01',
    'M16 12h6v6h-6a3 3 0 0 1 0-6z',
  ],
  creditCard: ['M2 7h20v12H2z', 'M2 11h20'],
  settings: [
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z',
  ],
  calendar: [
    'M3 4h18v18H3z',
    'M16 2v4',
    'M8 2v4',
    'M3 10h18',
  ],
  building: [
    'M3 21V7l9-4 9 4v14',
    'M9 9h.01',
    'M9 13h.01',
    'M9 17h.01',
    'M15 9h.01',
    'M15 13h.01',
    'M15 17h.01',
  ],
  listChecks: [
    'M9 6h11',
    'M9 12h11',
    'M9 18h11',
    'M3 5l2 2 3-3',
    'M3 11l2 2 3-3',
    'M3 17l2 2 3-3',
  ],
  bookOpen: [
    'M2 4h6a4 4 0 0 1 4 4v12a3 3 0 0 0-3-3H2z',
    'M22 4h-6a4 4 0 0 0-4 4v12a3 3 0 0 1 3-3h7z',
  ],
  search: ['M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z', 'M21 21l-4.35-4.35'],
  plus: ['M12 5v14', 'M5 12h14'],
  chevronRight: ['M9 6l6 6-6 6'],
  chevronDown: ['M6 9l6 6 6-6'],
  check: ['M5 12l5 5 9-11'],
  x: ['M6 6l12 12', 'M18 6l-12 12'],
  alert: [
    'M12 9v4',
    'M12 17h.01',
    'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z',
  ],
  inbox: [
    'M22 12h-6l-2 3h-4l-2-3H2',
    'M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z',
  ],
  fileText: [
    'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z',
    'M14 2v6h6',
    'M16 13H8',
    'M16 17H8',
    'M10 9H8',
  ],
  logOut: [
    'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4',
    'M16 17l5-5-5-5',
    'M21 12H9',
  ],
}

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName
  size?: number
}

export function Icon({ name, size = 16, className = '', ...rest }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`shrink-0 ${className}`}
      aria-hidden="true"
      {...rest}
    >
      {paths[name].map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  )
}

export type { IconName }
